"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAccess = exports.getMultipleBanks = void 0;
var react_i18next_1 = require("react-i18next");
var luxon_1 = require("luxon");
var getBankUrl = function (bank, currentIdentity) {
    var _a, _b, _c, _d, _e, _f;
    var lang = (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.language) || luxon_1.Settings.defaultLocale;
    if (!currentIdentity)
        return '';
    var queryParams = new URLSearchParams({
        countryCode: ((_b = (_a = currentIdentity.profile) === null || _a === void 0 ? void 0 : _a.catalogCoreCountry) === null || _b === void 0 ? void 0 : _b.iso2Code) ||
            ((_d = (_c = currentIdentity.profile) === null || _c === void 0 ? void 0 : _c.homeCoreLocation) === null || _d === void 0 ? void 0 : _d.country) ||
            '',
        programId: ((_e = bank === null || bank === void 0 ? void 0 : bank.programId) === null || _e === void 0 ? void 0 : _e.toString()) || '',
        refererUrl: '',
        locale: (lang || ((_f = navigator.languages) === null || _f === void 0 ? void 0 : _f[0]) || navigator.language).replace('-', '_'),
    });
    return "/catalog?".concat(queryParams);
};
var getMultipleBanks = function (layout, currentIdentity, hasMultipleBank) {
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    var multipleBanks = sort(((_a = layout === null || layout === void 0 ? void 0 : layout.bankBalance) === null || _a === void 0 ? void 0 : _a.map(function (bank) {
        var _a, _b;
        var accessCodes = (_a = bank === null || bank === void 0 ? void 0 : bank.accessCodeDetails) === null || _a === void 0 ? void 0 : _a.map(function (access) {
            var dateTime = luxon_1.DateTime.fromFormat(access.expiresAt, 'yyyy-MM-dd hh:mm:ss.S');
            return {
                category: t('prism-header:access-codes', 'Access Codes'),
                primary: access.accessCode,
                secondary: t('prism-header:expiring-access-codes', 'Expires {accessCodeDate}', {
                    accessCodeDate: dateTime.toLocaleString(luxon_1.DateTime.DATE_SHORT),
                }),
                url: getBankUrl(bank, currentIdentity),
            };
        });
        return {
            category: t('prism-header:bank-accounts', 'Bank Accounts'),
            primary: bank.bankName,
            secondary: (_b = bank === null || bank === void 0 ? void 0 : bank.points) === null || _b === void 0 ? void 0 : _b.toString(),
            url: getBankUrl(bank, currentIdentity),
            accessCodes: accessCodes,
            defaultBank: bank.defaultBank,
        };
    })) || [], 'defaultBank');
    var banksWithAccessCodes = multipleBanks === null || multipleBanks === void 0 ? void 0 : multipleBanks.filter(function (o) { return o.accessCodes && o.accessCodes.length > 0; });
    var accessCodes = banksWithAccessCodes === null || banksWithAccessCodes === void 0 ? void 0 : banksWithAccessCodes.flatMap(function (bank) {
        return bank.accessCodes || [];
    });
    var vettedMultipleBanks = multipleBanks === null || multipleBanks === void 0 ? void 0 : multipleBanks.map(function (bank) {
        return {
            category: bank.category,
            primary: bank.primary,
            secondary: bank.secondary,
            url: bank.url,
        };
    });
    return hasMultipleBank ? { vettedMultipleBanks: vettedMultipleBanks, accessCodes: accessCodes } : {};
};
exports.getMultipleBanks = getMultipleBanks;
var sort = function (arr, key) {
    return arr === null || arr === void 0 ? void 0 : arr.sort(function (a, b) {
        if (a[key])
            return -1;
        if (b[key])
            return 1;
        return 0;
    });
};
// sort multiple banks by default bank
var sortAccess = function (accessCodes) {
    return accessCodes === null || accessCodes === void 0 ? void 0 : accessCodes.sort(function (a, b) {
        var _a, _b, _c;
        var dateA = (_a = a.secondary) === null || _a === void 0 ? void 0 : _a.split(' ')[1];
        var dateB = (_b = b.secondary) === null || _b === void 0 ? void 0 : _b.split(' ')[1];
        return (new Date(dateA).getTime() - new Date(dateB).getTime() ||
            ((_c = a.secondary) === null || _c === void 0 ? void 0 : _c.localeCompare(b.secondary)));
    });
};
exports.sortAccess = sortAccess;
//# sourceMappingURL=multipleBanksFunctions.js.map